module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/service/Frame@2x (2).png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fservice%2FFrame%402x%20(2).png
// module id = EsaS
// module chunks = 93